import useGetCustomerForms from './useGetCustomerForms';
import useGetCustomerFiles from './useGetCustomerFiles';

function useGetCustomerFormsAndFilesTab({
  customerId,
  businessId,
}: {
  customerId: string;
  businessId: string;
}) {
  const forms = useGetCustomerForms({ customerId, businessId });
  const files = useGetCustomerFiles({ customerId, businessId });

  return {
    waiverRequests: forms.waiverRequests,
    files: files.files,
    isInitialLoading: forms.isInitialLoading || files.isInitialLoading,
    isFetchingFiles: files.isFetching,
    hasMoreFiles: files.hasMore,
    loadMoreFiles: files.loadMore,
    filesLoadMoreError: files.isFetchNextPageError,
    isError: forms.isError || files.isError,
    error: forms.error ?? files.error,
  };
}

export default useGetCustomerFormsAndFilesTab;
